"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pluralizeYears = exports.pluralizeTours = exports.pluralizeTouristsCount = exports.pluralizeTouristsAcc = exports.pluralizeTourists = exports.pluralizeReviews = exports.pluralizePoints = exports.pluralizePerson = exports.pluralizeOptions = exports.pluralizeOperators = exports.pluralizeOffers = exports.pluralizeNights = exports.pluralizeMinutesGen = exports.pluralizeLuggage = exports.pluralizeKids = exports.pluralizeHoursGen = exports.pluralizeHotels = exports.pluralizeFlights = exports.pluralizeDays = exports.pluralizeBySubject = exports.pluralizeAdults = void 0;

var _userflow = require("./userflow");

var _userflow2 = require("../constants/userflow");

var PLURAL = {
  YEARS: ['год', 'года', 'лет'],
  DAYS: ['день', 'дня', 'дней'],
  KIDS: ['ребёнок', 'ребёнка', 'детей'],
  ADULTS: ['взрослый', 'взрослых', 'взрослых'],
  NIGHTS: ['ночь', 'ночи', 'ночей'],
  TOURS: ['тур', 'тура', 'туров'],
  OFFERS: ['предложение', 'предложения', 'предложений'],
  FLIGHTS: ['рейс', 'рейса', 'рейсов'],
  OPTIONS: ['вариант', 'варианта', 'вариантов'],
  REVIEWS: ['отзыв', 'отзыва', 'отзывов'],
  POINTS: ['очко', 'очка', 'очков'],
  TOURISTS: ['турист', 'туриста', 'туристов'],
  TOURISTS_ACC: ['туриста', 'туристов', 'туристов'],
  HOURS_GEN: ['часе', 'часах', 'часах'],
  MINUTES_GEN: ['минуте', 'минутах', 'минутах'],
  LUGGAGE: ['место', 'места', 'мест'],
  PERSON: ['человек', 'человека', 'человек'],
  OPERATORS: ['туроператор', 'туроператора', 'туроператоров'],
  HOTELS: ['отель', 'отеля', 'отелей']
};

var pluralizeYears = function pluralizeYears(value) {
  return (0, _userflow.pluralize)(value, PLURAL.YEARS);
};

exports.pluralizeYears = pluralizeYears;

var pluralizeDays = function pluralizeDays(value) {
  return (0, _userflow.pluralize)(value, PLURAL.DAYS);
};

exports.pluralizeDays = pluralizeDays;

var pluralizeKids = function pluralizeKids(value) {
  return (0, _userflow.pluralize)(value, PLURAL.KIDS);
};

exports.pluralizeKids = pluralizeKids;

var pluralizeAdults = function pluralizeAdults(value) {
  return (0, _userflow.pluralize)(value, PLURAL.ADULTS);
};

exports.pluralizeAdults = pluralizeAdults;

var pluralizeNights = function pluralizeNights(value) {
  return (0, _userflow.pluralize)(value, PLURAL.NIGHTS);
};

exports.pluralizeNights = pluralizeNights;

var pluralizeTours = function pluralizeTours(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURS);
};

exports.pluralizeTours = pluralizeTours;

var pluralizeOffers = function pluralizeOffers(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OFFERS);
};

exports.pluralizeOffers = pluralizeOffers;

var pluralizeFlights = function pluralizeFlights(value) {
  return (0, _userflow.pluralize)(value, PLURAL.FLIGHTS);
};

exports.pluralizeFlights = pluralizeFlights;

var pluralizeOptions = function pluralizeOptions(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OPTIONS);
};

exports.pluralizeOptions = pluralizeOptions;

var pluralizeReviews = function pluralizeReviews(value) {
  return (0, _userflow.pluralize)(value, PLURAL.REVIEWS);
};

exports.pluralizeReviews = pluralizeReviews;

var pluralizePoints = function pluralizePoints(value) {
  return (0, _userflow.pluralize)(value, PLURAL.POINTS);
};

exports.pluralizePoints = pluralizePoints;

var pluralizeTouristsCount = function pluralizeTouristsCount(value) {
  return value === 1 ? "".concat(value).concat(_userflow2.NDASHS, "\u0433\u043E") : "".concat(value).concat(_userflow2.NDASHS, "\u0445");
};

exports.pluralizeTouristsCount = pluralizeTouristsCount;

var pluralizeTourists = function pluralizeTourists(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURISTS);
};

exports.pluralizeTourists = pluralizeTourists;

var pluralizeTouristsAcc = function pluralizeTouristsAcc(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURISTS_ACC);
};

exports.pluralizeTouristsAcc = pluralizeTouristsAcc;

var pluralizeHoursGen = function pluralizeHoursGen(value) {
  return (0, _userflow.pluralize)(value, PLURAL.HOURS_GEN);
};

exports.pluralizeHoursGen = pluralizeHoursGen;

var pluralizeMinutesGen = function pluralizeMinutesGen(value) {
  return (0, _userflow.pluralize)(value, PLURAL.MINUTES_GEN);
};

exports.pluralizeMinutesGen = pluralizeMinutesGen;

var pluralizeLuggage = function pluralizeLuggage(value) {
  return (0, _userflow.pluralize)(value, PLURAL.LUGGAGE);
};

exports.pluralizeLuggage = pluralizeLuggage;

var pluralizePerson = function pluralizePerson(value) {
  return (0, _userflow.pluralize)(value, PLURAL.PERSON);
};

exports.pluralizePerson = pluralizePerson;

var pluralizeOperators = function pluralizeOperators(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OPERATORS);
};

exports.pluralizeOperators = pluralizeOperators;

var pluralizeHotels = function pluralizeHotels(value) {
  return (0, _userflow.pluralize)(value, PLURAL.HOTELS);
};

exports.pluralizeHotels = pluralizeHotels;

var pluralizeBySubject = function pluralizeBySubject(value, subject) {
  return (0, _userflow.pluralize)(value, PLURAL[subject]);
};

exports.pluralizeBySubject = pluralizeBySubject;